var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var defaultConfig = { endpoint: 'photo-users' };
var init = function (webOrMobileLogger) { return function (userConfig) {
    if (userConfig === void 0) { userConfig = {}; }
    var defaults = userConfig.defaults, restOfConfig = __rest(userConfig, ["defaults"]);
    var config = __assign(__assign({}, defaultConfig), restOfConfig);
    var factoryInstance = typeof webOrMobileLogger.factory === 'function' ? webOrMobileLogger.factory(config) : webOrMobileLogger;
    var logger = getLogger(factoryInstance);
    return defaults ? logger.util.updateDefaults(defaults) : logger;
}; };
var initCustomLogger = function (factoryInstance) { return getLogger(factoryInstance); };
var getLogger = function (biLoggerClientFactoryInstance) {
    return new Logger(biLoggerClientFactoryInstance);
};
var Logger = /** @class */ (function () {
    function Logger(biLoggerClientFactoryInstance) {
        var _this = this;
        this.biLoggerClientFactoryInstance = biLoggerClientFactoryInstance;
        this.util = {
            updateDefaults: function (defaults) {
                _this.biLoggerClientFactoryInstance.updateDefaults(defaults);
                return _this;
            },
            log: function (logParams, context) {
                return _this.bi.log(logParams, context);
            }
        };
        biLoggerClientFactoryInstance.updateDefaults({ src: 65 });
        this.bi = biLoggerClientFactoryInstance.logger({});
    }
    Logger.prototype.albumsListView = function (params) {
        return this.bi.log(__assign({ evid: 100, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.topMenu = function (params) {
        return this.bi.log(__assign({ evid: 101, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.newPhotoSite = function (params) {
        return this.bi.log(__assign({ evid: 102, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.searchAlbum = function (params) {
        return this.bi.log(__assign({ evid: 103, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.deleteAlbum = function (params) {
        return this.bi.log(__assign({ evid: 104, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.editAlbum = function (params) {
        return this.bi.log(__assign({ evid: 105, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.shareAlbum = function (params) {
        return this.bi.log(__assign({ evid: 106, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.viewPublishedSite = function (params) {
        return this.bi.log(__assign({ evid: 108, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.wizardStarted = function (params) {
        return this.bi.log(__assign({ evid: 109, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.wizardStepDetails = function (params) {
        return this.bi.log(__assign({ evid: 110, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.wizardTypeClick = function (params) {
        return this.bi.log(__assign({ evid: 111, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.wizardLayoutClick = function (params) {
        return this.bi.log(__assign({ evid: 112, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.wizardStepUpload = function (params) {
        return this.bi.log(__assign({ evid: 113, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.wizardNext = function (params) {
        return this.bi.log(__assign({ evid: 114, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.editorPreviewImages = function (params) {
        return this.bi.log(__assign({ evid: 115, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.editorLoadingComplete = function (params) {
        return this.bi.log(__assign({ evid: 116, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.editorUploadImages = function (params) {
        return this.bi.log(__assign({ evid: 117, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.editorClickOnSet = function (params) {
        return this.bi.log(__assign({ evid: 118, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.editorEditSet = function (params) {
        return this.bi.log(__assign({ evid: 119, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.editorUploadMorePhotos = function (params) {
        return this.bi.log(__assign({ evid: 120, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.editorDeletePhoto = function (params) {
        return this.bi.log(__assign({ evid: 121, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.editorNewSet = function (params) {
        return this.bi.log(__assign({ evid: 122, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.editorReorderPhotos = function (params) {
        return this.bi.log(__assign({ evid: 123, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.editorChangeDesign = function (params) {
        return this.bi.log(__assign({ evid: 124, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.editorTopMenu = function (params) {
        return this.bi.log(__assign({ evid: 128, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.wizardUploadTrigger = function (params) {
        return this.bi.log(__assign({ evid: 129, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.wizardClose = function (params) {
        return this.bi.log(__assign({ evid: 130, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.wizardBack = function (params) {
        return this.bi.log(__assign({ evid: 131, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.loadingScreen = function (params) {
        return this.bi.log(__assign({ evid: 132, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.editorDialogHelp = function (params) {
        return this.bi.log(__assign({ evid: 133, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.editorUploadTrigger = function (params) {
        return this.bi.log(__assign({ evid: 134, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.editorResizeImagesView = function (params) {
        return this.bi.log(__assign({ evid: 136, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.editorSelectAllImages = function (params) {
        return this.bi.log(__assign({ evid: 137, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.editorClearAllImages = function (params) {
        return this.bi.log(__assign({ evid: 138, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.editorCutImages = function (params) {
        return this.bi.log(__assign({ evid: 139, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.editorCopyImages = function (params) {
        return this.bi.log(__assign({ evid: 140, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.editorDeleteImages = function (params) {
        return this.bi.log(__assign({ evid: 141, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.editorPasteImages = function (params) {
        return this.bi.log(__assign({ evid: 142, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.editorSetPermission = function (params) {
        return this.bi.log(__assign({ evid: 143, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.editorDownloadPermission = function (params) {
        return this.bi.log(__assign({ evid: 144, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.editorDeleteSet = function (params) {
        return this.bi.log(__assign({ evid: 145, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.publish = function (params) {
        return this.bi.log(__assign({ evid: 146, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.openDialog = function (params) {
        return this.bi.log(__assign({ evid: 147, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.clientError = function (params) {
        return this.bi.log(__assign({ evid: 148, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.settingsManageAlbumsClick = function (params) {
        return this.bi.log(__assign({ evid: 150, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.settingsLayoutSelected = function (params) {
        return this.bi.log(__assign({ evid: 151, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.settingsMyAlbumsAlbumVisible = function (params) {
        return this.bi.log(__assign({ evid: 153, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.settingsMyAlbumsAlbumEdit = function (params) {
        return this.bi.log(__assign({ evid: 154, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.publishStart = function (params) {
        return this.bi.log(__assign({ evid: 158, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.publishError = function (params) {
        return this.bi.log(__assign({ evid: 159, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.refreshSeoParamsEnded = function (params) {
        return this.bi.log(__assign({ evid: 160, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.generateDownloadLinkStarted = function (params) {
        return this.bi.log(__assign({ evid: 161, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.saveInSantaEnded = function (params) {
        return this.bi.log(__assign({ evid: 162, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.saveInSantaFailed = function (params) {
        return this.bi.log(__assign({ evid: 163, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.publishInSantaEnded = function (params) {
        return this.bi.log(__assign({ evid: 164, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.publishInAlbumsEnded = function (params) {
        return this.bi.log(__assign({ evid: 165, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.publishInAlbumsFailed = function (params) {
        return this.bi.log(__assign({ evid: 166, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.publishInSantaFailed = function (params) {
        return this.bi.log(__assign({ evid: 167, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.refreshSeoParamsStarted = function (params) {
        return this.bi.log(__assign({ evid: 168, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.albumActionsUpdateEnded = function (params) {
        return this.bi.log(__assign({ evid: 169, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.generateDownloadLinkForSetEnded = function (params) {
        return this.bi.log(__assign({ evid: 170, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.clickOnUpgrade = function (params) {
        return this.bi.log(__assign({ evid: 171, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.clickOnTransfer = function (params) {
        return this.bi.log(__assign({ evid: 172, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.albumPublishPopup = function (params) {
        return this.bi.log(__assign({ evid: 173, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.settingsLoad = function (params) {
        return this.bi.log(__assign({ evid: 174, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.proGalleryLoadUsers = function (params) {
        return this.bi.log(__assign({ evid: 177, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.photoAlbumDashboardNavigation = function (params) {
        return this.bi.log(__assign({ evid: 178, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.photoStatsTipClick = function (params) {
        return this.bi.log(__assign({ evid: 179, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.photoAlbumAppleCreate = function (params) {
        return this.bi.log(__assign({ evid: 181, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.proGallerySettingsStartNow = function (params) {
        return this.bi.log(__assign({ evid: 182, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.nativePhotoAlbumAction = function (params) {
        return this.bi.log(__assign({ evid: 183, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.artStoreCompletedBusinessInfo = function (params) {
        return this.bi.log(__assign({ evid: 184, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.photoAlbumStoreToggleActive = function (params) {
        return this.bi.log(__assign({ evid: 185, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.photoAlbumStoreToggleWatermark = function (params) {
        return this.bi.log(__assign({ evid: 186, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.photoAlbumStoreSetPricing = function (params) {
        return this.bi.log(__assign({ evid: 187, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.photoAlbumStoreCompletedBusinessInfo = function (params) {
        return this.bi.log(__assign({ evid: 188, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.photoAlbumStoreCompletedSetUpStore = function (params) {
        return this.bi.log(__assign({ evid: 189, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.startUploadToMediaSingleItem = function (params) {
        return this.bi.log(__assign({ evid: 190, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.endUploadToMediaSingleItem = function (params) {
        return this.bi.log(__assign({ evid: 191, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.startUploadToMediaBatch = function (params) {
        return this.bi.log(__assign({ evid: 192, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.endUploadToMediaBatch = function (params) {
        return this.bi.log(__assign({ evid: 193, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.imageThumbnailCreated = function (params) {
        return this.bi.log(__assign({ evid: 194, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.firstOpenProofingWizard = function (params) {
        return this.bi.log(__assign({ evid: 195, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.userClickOnStartProofingWizard = function (params) {
        return this.bi.log(__assign({ evid: 196, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.createCollection = function (params) {
        return this.bi.log(__assign({ evid: 198, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.collectionCreated = function (params) {
        return this.bi.log(__assign({ evid: 199, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.photoAlbumSettingsOpen = function (params) {
        return this.bi.log(__assign({ evid: 200, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.photoAlbumSettingsChange = function (params) {
        return this.bi.log(__assign({ evid: 201, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.photoAlbumRemoveMedia = function (params) {
        return this.bi.log(__assign({ evid: 202, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.photoAlbumChangeText = function (params) {
        return this.bi.log(__assign({ evid: 203, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.photoAlbumPageAction = function (params) {
        return this.bi.log(__assign({ evid: 204, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.inviteMembersToCollection = function (params) {
        return this.bi.log(__assign({ evid: 206, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.openProofingBo = function (params) {
        return this.bi.log(__assign({ evid: 207, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.openWizardCreateCollection = function (params) {
        return this.bi.log(__assign({ evid: 208, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.openCollectionActionMenu = function (params) {
        return this.bi.log(__assign({ evid: 209, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.photoAlbumPageOnLoad = function (params) {
        return this.bi.log(__assign({ evid: 210, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.photoAlbumButtonOnClick = function (params) {
        return this.bi.log(__assign({ evid: 211, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.photoAlbumAppOnSave = function (params) {
        return this.bi.log(__assign({ evid: 212, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.photoAlbumItemOnAction = function (params) {
        return this.bi.log(__assign({ evid: 213, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.photoAlbumAppOnPublish = function (params) {
        return this.bi.log(__assign({ evid: 214, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.clickOnActionFromCollectionActionMenu = function (params) {
        return this.bi.log(__assign({ evid: 215, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.clickOnDownloadFilesFromCollection = function (params) {
        return this.bi.log(__assign({ evid: 216, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.clickOnViewCollection = function (params) {
        return this.bi.log(__assign({ evid: 217, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.downloadFilesFromCollection = function (params) {
        return this.bi.log(__assign({ evid: 218, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.viewItemInTheCollection = function (params) {
        return this.bi.log(__assign({ evid: 221, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.navigateInTheCollectionBzmArea = function (params) {
        return this.bi.log(__assign({ evid: 222, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.openMemberActionMenu = function (params) {
        return this.bi.log(__assign({ evid: 223, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.clickOnActionInMemberMenu = function (params) {
        return this.bi.log(__assign({ evid: 224, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.editCollection = function (params) {
        return this.bi.log(__assign({ evid: 225, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.editProofingSetting = function (params) {
        return this.bi.log(__assign({ evid: 226, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.saveProofingSetting = function (params) {
        return this.bi.log(__assign({ evid: 227, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.clickOnSelectMediaCollection = function (params) {
        return this.bi.log(__assign({ evid: 228, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.addCommentOnAnItemCollection = function (params) {
        return this.bi.log(__assign({ evid: 229, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.clickSaveCollection = function (params) {
        return this.bi.log(__assign({ evid: 232, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.clickOnInviteMemberToCollection = function (params) {
        return this.bi.log(__assign({ evid: 233, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.navigationInCollectionMemberArea = function (params) {
        return this.bi.log(__assign({ evid: 234, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.hintClick = function (params) {
        return this.bi.log(__assign({ evid: 236, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.settingsClickCreateAlbum = function (params) {
        return this.bi.log(__assign({ evid: 237, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.settingsClickViewAlbumsList = function (params) {
        return this.bi.log(__assign({ evid: 238, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.paSettingsViewMain = function (params) {
        return this.bi.log(__assign({ evid: 239, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.settingsClickDownloadLrPlugin = function (params) {
        return this.bi.log(__assign({ evid: 240, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.photoAlbumsClickOnSearch = function (params) {
        return this.bi.log(__assign({ evid: 241, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.photoAlbumsClickOnSort = function (params) {
        return this.bi.log(__assign({ evid: 242, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.photoAlbumsSearchInAlbumList = function (params) {
        return this.bi.log(__assign({ evid: 243, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.photoAlbumsFilterClick = function (params) {
        return this.bi.log(__assign({ evid: 244, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.openPhotoAlbumsSettingsAdi = function (params) {
        return this.bi.log(__assign({ evid: 245, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.chooseAlbumAppearanceOption = function (params) {
        return this.bi.log(__assign({ evid: 247, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.clickReorderInManualSorting = function (params) {
        return this.bi.log(__assign({ evid: 250, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.clickEditAlbumsVisibility = function (params) {
        return this.bi.log(__assign({ evid: 251, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.changeToggleInAlbumsVisibility = function (params) {
        return this.bi.log(__assign({ evid: 252, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.changeAlbumsOrderDisplay = function (params) {
        return this.bi.log(__assign({ evid: 253, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.clickNavigationButtonInAdiSettings = function (params) {
        return this.bi.log(__assign({ evid: 254, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.adiSettingsClickManageAlbums = function (params) {
        return this.bi.log(__assign({ evid: 255, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.buttonClickInAlbumSettings = function (params) {
        return this.bi.log(__assign({ evid: 256, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.toggleClickShoeMemberLoginProofing = function (params) {
        return this.bi.log(__assign({ evid: 257, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.clickLoginProofingSettings = function (params) {
        return this.bi.log(__assign({ evid: 258, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.clickDoneProofingSettings = function (params) {
        return this.bi.log(__assign({ evid: 259, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.popupBannerHideMemberLoginOpen = function (params) {
        return this.bi.log(__assign({ evid: 260, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.popupBannerHideMemberLoginClick = function (params) {
        return this.bi.log(__assign({ evid: 261, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.clickLearnMoreInProofingBo = function (params) {
        return this.bi.log(__assign({ evid: 263, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.popupAlbumIsNotPublishedProofing = function (params) {
        return this.bi.log(__assign({ evid: 264, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.popupAlbumIsNotPublishedClickProofing = function (params) {
        return this.bi.log(__assign({ evid: 265, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.popupLockListProofingOpen = function (params) {
        return this.bi.log(__assign({ evid: 266, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.popupLockListProofingClick = function (params) {
        return this.bi.log(__assign({ evid: 267, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.userClickAfterCreateList = function (params) {
        return this.bi.log(__assign({ evid: 268, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.filterListsInTheBo = function (params) {
        return this.bi.log(__assign({ evid: 269, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.clickOnViewAndEditProofingList = function (params) {
        return this.bi.log(__assign({ evid: 270, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.click3DotsInListProofing = function (params) {
        return this.bi.log(__assign({ evid: 271, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.clickOn3DotsActionProofingList = function (params) {
        return this.bi.log(__assign({ evid: 272, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.receivedMediaToUpload = function (params) {
        return this.bi.log(__assign({ evid: 275, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.organizeMediaClickActionButton = function (params) {
        return this.bi.log(__assign({ evid: 276, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.organizeMediaRearrangeGallery = function (params) {
        return this.bi.log(__assign({ evid: 277, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.organizeMediaChangeSettings = function (params) {
        return this.bi.log(__assign({ evid: 278, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.popupOpened = function (params) {
        return this.bi.log(__assign({ evid: 279, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.actionInCollection = function (params) {
        return this.bi.log(__assign({ evid: 280, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.viewItemCommentInCollection = function (params) {
        return this.bi.log(__assign({ evid: 281, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.actionInCollectionsCommentsModal = function (params) {
        return this.bi.log(__assign({ evid: 282, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.hover = function (params) {
        return this.bi.log(__assign({ evid: 283, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.proGalleryDownloadLr = function (params) {
        return this.bi.log(__assign({ evid: 286, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.settingsNavigation = function (params) {
        return this.bi.log(__assign({ evid: 287, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.clickButtonInAddOnsModal = function (params) {
        return this.bi.log(__assign({ evid: 290, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.settingsClickCreateAlbumSrc65Evid292 = function (params) {
        return this.bi.log(__assign({ evid: 292, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.albumNameError = function (params) {
        return this.bi.log(__assign({ evid: 294, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.deleteGog = function (params) {
        return this.bi.log(__assign({ evid: 296, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.clickActionInPhotoAlbumsBo = function (params) {
        return this.bi.log(__assign({ evid: 298, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.clickManageMediaButton = function (params) {
        return this.bi.log(__assign({ evid: 299, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.albumActions = function (params) {
        return this.bi.log(__assign({ evid: 300, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.oaPhotoAlbumClickCreateAlbum = function (params) {
        return this.bi.log(__assign({ evid: 308, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.oaPhotoAlbumAlbumCreated = function (params) {
        return this.bi.log(__assign({ evid: 310, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.oaPhotoAlbumAlbumPublished = function (params) {
        return this.bi.log(__assign({ evid: 311, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.changeSettings = function (params) {
        return this.bi.log(__assign({ evid: 401, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.mangeMediaUpperPanelOpen = function (params) {
        return this.bi.log(__assign({ evid: 402, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.proGallerySettingsLoaded = function (params) {
        return this.bi.log(__assign({ evid: 403, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.manageMediaSet = function (params) {
        return this.bi.log(__assign({ evid: 404, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.uploadMedia = function (params) {
        return this.bi.log(__assign({ evid: 406, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.uploadMediaError = function (params) {
        return this.bi.log(__assign({ evid: 407, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.removeMedia = function (params) {
        return this.bi.log(__assign({ evid: 408, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.proGallerySettingsNavigation = function (params) {
        return this.bi.log(__assign({ evid: 411, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.galleryPublished = function (params) {
        return this.bi.log(__assign({ evid: 412, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.customizeLayout = function (params) {
        return this.bi.log(__assign({ evid: 413, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.organizeMediaEditQualityClick = function (params) {
        return this.bi.log(__assign({ evid: 420, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.singleImageSettingsApply = function (params) {
        return this.bi.log(__assign({ evid: 421, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.singleImageSettingsCancel = function (params) {
        return this.bi.log(__assign({ evid: 422, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.organizeMediaReplaceImage = function (params) {
        return this.bi.log(__assign({ evid: 423, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.oaClickOnGallery = function (params) {
        return this.bi.log(__assign({ evid: 513, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.oaGalleryLayoutChange = function (params) {
        return this.bi.log(__assign({ evid: 514, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.oaGalleryShare = function (params) {
        return this.bi.log(__assign({ evid: 515, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.oaClickOnMedia = function (params) {
        return this.bi.log(__assign({ evid: 516, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.oaDownloadMedia = function (params) {
        return this.bi.log(__assign({ evid: 517, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.oaItemShare = function (params) {
        return this.bi.log(__assign({ evid: 518, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.oaClickOnMediaInExpand = function (params) {
        return this.bi.log(__assign({ evid: 519, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.oaGalleriesFilter = function (params) {
        return this.bi.log(__assign({ evid: 522, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.oaManageGalleryAction = function (params) {
        return this.bi.log(__assign({ evid: 523, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.oaSaveSettings = function (params) {
        return this.bi.log(__assign({ evid: 524, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.oaGalleriesSettingsClick = function (params) {
        return this.bi.log(__assign({ evid: 525, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.oaGalleryVisibilityInGalleriesSettings = function (params) {
        return this.bi.log(__assign({ evid: 526, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.oaReorderGalleryInGalleriesSettings = function (params) {
        return this.bi.log(__assign({ evid: 527, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.oaCloseGalleriesSettings = function (params) {
        return this.bi.log(__assign({ evid: 528, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.oaManageMediaOrderMedia = function (params) {
        return this.bi.log(__assign({ evid: 529, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.oaManageMediaClickOnItem = function (params) {
        return this.bi.log(__assign({ evid: 530, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.oaManageMediaReplaceItem = function (params) {
        return this.bi.log(__assign({ evid: 531, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.oaManageMediaEditItemSave = function (params) {
        return this.bi.log(__assign({ evid: 532, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.oaManageMediaDeleteItem = function (params) {
        return this.bi.log(__assign({ evid: 533, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.oaManageMediaAddItem = function (params) {
        return this.bi.log(__assign({ evid: 534, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.oaPhotoAlbumViewAlbum = function (params) {
        return this.bi.log(__assign({ evid: 535, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.oaPhotoAlbumAlbumAction = function (params) {
        return this.bi.log(__assign({ evid: 536, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.oaPhotoAlbumSaveSettings = function (params) {
        return this.bi.log(__assign({ evid: 537, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.oaPhotoAlbumReplaceCover = function (params) {
        return this.bi.log(__assign({ evid: 538, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.oaPhotoAlbumShare = function (params) {
        return this.bi.log(__assign({ evid: 539, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.oaPhotoAlbumNavigation = function (params) {
        return this.bi.log(__assign({ evid: 540, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.oaArtStoreViewOrder = function (params) {
        return this.bi.log(__assign({ evid: 541, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.oaArtStoreContactCustomer = function (params) {
        return this.bi.log(__assign({ evid: 542, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.oaArtStoreSearchOrder = function (params) {
        return this.bi.log(__assign({ evid: 543, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.oaGalleriesActionMenuPress = function (params) {
        return this.bi.log(__assign({ evid: 544, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.oaOpenEditGalleries = function (params) {
        return this.bi.log(__assign({ evid: 545, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.oaChangeGalleryOrder = function (params) {
        return this.bi.log(__assign({ evid: 546, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.oaCloseEditGalleries = function (params) {
        return this.bi.log(__assign({ evid: 547, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.oaGalleryCreateGalleryClick = function (params) {
        return this.bi.log(__assign({ evid: 548, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.oaGalleryGalleryCreated = function (params) {
        return this.bi.log(__assign({ evid: 549, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.oaGalleryError = function (params) {
        return this.bi.log(__assign({ evid: 550, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.manageMediaClick = function (params) {
        return this.bi.log(__assign({ evid: 700, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.storeSetUpClick = function (params) {
        return this.bi.log(__assign({ evid: 702, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.expandSettings = function (params) {
        return this.bi.log(__assign({ evid: 703, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.expandModeDone = function (params) {
        return this.bi.log(__assign({ evid: 704, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.watermarkSettings = function (params) {
        return this.bi.log(__assign({ evid: 705, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.watermarkEnable = function (params) {
        return this.bi.log(__assign({ evid: 706, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.cartSettings = function (params) {
        return this.bi.log(__assign({ evid: 708, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.cartDesignTab = function (params) {
        return this.bi.log(__assign({ evid: 709, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.licenseCreateLicenseClick = function (params) {
        return this.bi.log(__assign({ evid: 712, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.licenseUploadLicense = function (params) {
        return this.bi.log(__assign({ evid: 713, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.licenseNewLicenseSave = function (params) {
        return this.bi.log(__assign({ evid: 714, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.licenseLicenseEdit = function (params) {
        return this.bi.log(__assign({ evid: 715, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.licenseLicenseDelete = function (params) {
        return this.bi.log(__assign({ evid: 716, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.licenseClickChangeCurrency = function (params) {
        return this.bi.log(__assign({ evid: 717, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.licenseQualityToggle = function (params) {
        return this.bi.log(__assign({ evid: 718, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.licenseToggle = function (params) {
        return this.bi.log(__assign({ evid: 719, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.licenseSetPrice = function (params) {
        return this.bi.log(__assign({ evid: 720, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.licenseSave = function (params) {
        return this.bi.log(__assign({ evid: 721, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.manageStoreBusinessInfo = function (params) {
        return this.bi.log(__assign({ evid: 722, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.manageStoreEmailSettings = function (params) {
        return this.bi.log(__assign({ evid: 723, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.manageStoreAddLogo = function (params) {
        return this.bi.log(__assign({ evid: 724, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.manageStoreLocale = function (params) {
        return this.bi.log(__assign({ evid: 725, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.manageStoreLoad = function (params) {
        return this.bi.log(__assign({ evid: 726, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.artStoreDashboardNavigation = function (params) {
        return this.bi.log(__assign({ evid: 727, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.artStoreSaveBusinessInfo = function (params) {
        return this.bi.log(__assign({ evid: 728, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.artStoreStartNow = function (params) {
        return this.bi.log(__assign({ evid: 729, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.artStoreChooseSellingMethod = function (params) {
        return this.bi.log(__assign({ evid: 730, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.artStorePerformance = function (params) {
        return this.bi.log(__assign({ evid: 731, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.artStoreNavigation = function (params) {
        return this.bi.log(__assign({ evid: 732, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.artStoreConnectProvider = function (params) {
        return this.bi.log(__assign({ evid: 734, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.supportQuestionClick = function (params) {
        return this.bi.log(__assign({ evid: 901, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.selectStoragePackage = function (params) {
        return this.bi.log(__assign({ evid: 902, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.selectOcusPackage = function (params) {
        return this.bi.log(__assign({ evid: 903, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.clickCheckoutInOcus = function (params) {
        return this.bi.log(__assign({ evid: 904, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.nativeGallerySettingsNavigation = function (params) {
        return this.bi.log(__assign({ evid: 905, src: 65 }, params), { endpoint: 'photo-users' });
    };
    Logger.prototype.nativeGalleryChangeSettings = function (params) {
        return this.bi.log(__assign({ evid: 906, src: 65 }, params), { endpoint: 'photo-users' });
    };
    return Logger;
}());
export { Logger };
export default init;
export function getLoggerConf() {
    return {
        src: 65,
        endpoint: 'photo-users'
    };
}
//# sourceMappingURL=index.js.map